import React from 'react';
import { Stack, FormControl, FormLabel, Input, Textarea, Typography, Link } from '@mui/joy';

interface CreateAccountStepProps {
  data: {
    companyName: string;
    location: string;
    fullName: string;
    email: string;
    password: string;
  };
  onUpdate: (updates: any) => void;
}

const CreateAccountStep: React.FC<CreateAccountStepProps> = ({ data, onUpdate }) => {
  return (
    <Stack spacing={3}>
      {/* Company Name */}
      <FormControl>
        <FormLabel sx={{ fontWeight: 600, color: '#1A1B1D' }}>
          Company Name *
        </FormLabel>
        <Input
          value={data.companyName}
          onChange={(e) => onUpdate({ companyName: e.target.value })}
          placeholder="Your company name"
          sx={{
            height: '56px',
            backgroundColor: '#ECEFF3',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1.125rem',
            color: '#1A1B1D',
            '--Input-focusedHighlight': 'transparent !important',
            '&::placeholder': {
              color: '#7B7F85 !important',
              opacity: 1,
            },
            '&:hover': {
              backgroundColor: '#ECEFF3',
            },
            '&:focus': {
              outline: 'none',
            },
            '&:focus-within': {
              backgroundColor: '#ECEFF3',
            },
          }}
        />
      </FormControl>

      {/* Location */}
      <FormControl>
        <FormLabel sx={{ fontWeight: 600, color: '#1A1B1D' }}>
          Location *
        </FormLabel>
        <Input
          value={data.location}
          onChange={(e) => onUpdate({ location: e.target.value })}
          placeholder="Your street address"
          sx={{
            height: '56px',
            backgroundColor: '#ECEFF3',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1.125rem',
            color: '#1A1B1D',
            '--Input-focusedHighlight': 'transparent !important',
            '&::placeholder': {
              color: '#7B7F85 !important',
              opacity: 1,
            },
            '&:hover': {
              backgroundColor: '#ECEFF3',
            },
            '&:focus': {
              outline: 'none',
            },
            '&:focus-within': {
              backgroundColor: '#ECEFF3',
            },
          }}
        />
        <Typography level="body-sm" sx={{ color: '#7B7F85', mt: 0.5 }}>
          Where you'll interview candidates. Can be changed later.
        </Typography>
      </FormControl>

      {/* Full Name */}
      <FormControl>
        <FormLabel sx={{ fontWeight: 600, color: '#1A1B1D' }}>
          Your Full Name *
        </FormLabel>
        <Input
          value={data.fullName}
          onChange={(e) => onUpdate({ fullName: e.target.value })}
          placeholder="Your full name"
          sx={{
            height: '56px',
            backgroundColor: '#ECEFF3',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1.125rem',
            color: '#1A1B1D',
            '--Input-focusedHighlight': 'transparent !important',
            '&::placeholder': {
              color: '#7B7F85 !important',
              opacity: 1,
            },
            '&:hover': {
              backgroundColor: '#ECEFF3',
            },
            '&:focus': {
              outline: 'none',
            },
            '&:focus-within': {
              backgroundColor: '#ECEFF3',
            },
          }}
        />
      </FormControl>

      {/* Email Address */}
      <FormControl>
        <FormLabel sx={{ fontWeight: 600, color: '#1A1B1D' }}>
          Email Address *
        </FormLabel>
        <Input
          type="email"
          value={data.email}
          onChange={(e) => onUpdate({ email: e.target.value })}
          placeholder="Your.email@example.com"
          sx={{
            height: '56px',
            backgroundColor: '#ECEFF3',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1.125rem',
            color: '#1A1B1D',
            '--Input-focusedHighlight': 'transparent !important',
            '&::placeholder': {
              color: '#7B7F85 !important',
              opacity: 1,
            },
            '&:hover': {
              backgroundColor: '#ECEFF3',
            },
            '&:focus': {
              outline: 'none',
            },
            '&:focus-within': {
              backgroundColor: '#ECEFF3',
            },
          }}
        />
      </FormControl>

      {/* Password */}
      <FormControl>
        <FormLabel sx={{ fontWeight: 600, color: '#1A1B1D' }}>
          Password *
        </FormLabel>
        <Input
          type="password"
          value={data.password}
          onChange={(e) => onUpdate({ password: e.target.value })}
          placeholder="Create a password"
          sx={{
            height: '56px',
            backgroundColor: '#ECEFF3',
            borderRadius: '12px',
            border: 'none',
            fontSize: '1.125rem',
            color: '#1A1B1D',
            '--Input-focusedHighlight': 'transparent !important',
            '&::placeholder': {
              color: '#7B7F85 !important',
              opacity: 1,
            },
            '&:hover': {
              backgroundColor: '#ECEFF3',
            },
            '&:focus': {
              outline: 'none',
            },
            '&:focus-within': {
              backgroundColor: '#ECEFF3',
            },
          }}
        />
      </FormControl>

      <Typography level="body-sm" sx={{ color: '#7B7F85', textAlign: 'center', mt: 2 }}>
        By creating an account, you agree to our{' '}
        <Link 
          href="/terms" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ 
            color: '#2e2d7e', 
            textDecoration: 'underline',
            '&:hover': {
              color: '#1a1a5e'
            }
          }}
        >
          Terms of Service
        </Link>
        {' '}and{' '}
        <Link 
          href="/privacy" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ 
            color: '#2e2d7e', 
            textDecoration: 'underline',
            '&:hover': {
              color: '#1a1a5e'
            }
          }}
        >
          Privacy Policy
        </Link>
        .
      </Typography>
    </Stack>
  );
};

export default CreateAccountStep;
